import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

// FIXME if we are not using this probably we should delete it

@observer
export class HtmlCard extends React.Component {
  render() {
    // const { notification } = this.props;
    // const { targetApp } = notification;
    // return <div dangerouslySetInnerHTML={{ __html }} />;
    return null;
  }
}

HtmlCard.propTypes = {
  notification: PropTypes.object,
};
